import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
  data: null,
  fetching: false,
  hasError: false
}

const configSlice = createSlice({
  initialState,
  name: 'ukFrictions',
  reducers: {
    error(state) {
      state.fetching = false
      state.hasError = true
    },
    fetch(state) {
      state.fetching = true
    },
    set(state, action) {
      state.hasError = false
      state.fetching = false
      state.data = action.payload
    }
  }
})

export const { actions } = configSlice
export default configSlice.reducer
